/**
 * Card — 文档卡、生词条卡
 */

import { HTMLAttributes, forwardRef } from 'react';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  selected?: boolean;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ selected = false, className = '', children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={`rounded-lg bg-white dark:bg-warm-dark border border-border-warm dark:border-border-warm-dark p-4 shadow-sm transition-all ${
          selected
            ? 'ring-2 ring-oasis border-transparent'
            : 'hover:shadow-md hover:border-camel cursor-pointer'
        } ${className}`}
        {...props}
      >
        {children}
      </div>
    );
  }
);

Card.displayName = 'Card';
